<template>
  <div class="not-found">
    <div class="msg-box">
      <h1 class="animated fadeInDown">404 Not Found</h1>
      <h2 class="animated fadeInUp">
        ¡Uy!
        <br />Parece que esta pagina no existe.
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
</style>
